
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.186 7.186H8.813V.813a.814.814 0 10-1.627 0v6.373H.813a.814.814 0 100 1.627h6.373v6.373a.814.814 0 001.627 0V8.813h6.373a.814.814 0 000-1.627z","fill":"#fc8308"}})])
          )
        }
      }
    